import Body from './Fields/Body';
import Image from './Fields/Image';

export interface VintageGuitarArticleResponseData {
    current_page: number;
    last_page: number;
    data: VintageGuitarArticle[];
    first_page_url: string;
    prev_page_url: string;
    next_page_url: string;
    last_page_url: string;
    from: number;
    to: number;
    per_page: number;
    total: number;
}

// todo listing vs detail types

export interface VintageGuitarArticle {
    nid: number;
    vid: number;
    type: string;
    language: string;
    title: string;
    uid: number;
    status: number;
    created: number;    // Numeric date
    changed: number;    // Numeric date
    comment: number;
    promote: number;
    sticky: number;
    tnid: number;
    translate: number;
    alias: string;
    body: Body;
    // field_image: Image;
    instrument_refs: any;
    meta_title: string;
    meta_description: string;
    field_instr_image: Image[];
}

export interface GetVintageGuitarArticleOptions {
    results_per_page: number;
    page: number;
    [key: string]: number;
}

export const GetVintageGuitarArticleOptionsKeys = [
    'results_per_page', 'page'
];



// WEBPACK FOOTER //
// ./src/types/drupal/VintageGuitarArticleNode.ts